module.exports = {
          srcSet: __webpack_public_path__ + "b2daf66f5494b15797f174c43494f83f-1569.png"+" 1569w",
          images:[ {path: __webpack_public_path__ + "b2daf66f5494b15797f174c43494f83f-1569.png",width: 1569,height: 406}],
          src: __webpack_public_path__ + "b2daf66f5494b15797f174c43494f83f-1569.png",
          toString:function(){return __webpack_public_path__ + "b2daf66f5494b15797f174c43494f83f-1569.png"},
          
          width: 1569,
          height: 406
        }